import { IonicPage, ModalController } from 'ionic-angular';
import { Component } from '@angular/core';
import { AppConfig } from '../../../../app/app.config';
import { DailyLogModalPage } from '../../../daily-log/daily-log-modal/daily-log-modal';

@IonicPage()
@Component({
  selector: 'page-dpr-attachments-edit',
  templateUrl: 'dpr-attachments-edit.html',
})
export class DprAttachmentsEditPage {
  config = AppConfig.settings;

  constructor(public modalController: ModalController) {
  }

  ionViewDidLoad() {
  }

  openDailyLogModal() {
    const dailyLogModal = this.modalController.create(DailyLogModalPage);
    dailyLogModal.present();
  }
}


// WEBPACK FOOTER //
// ./src/pages/DPR Pages/dpr-attachments/dpr-attachments-edit/dpr-attachments-edit.ts